import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import Select from 'components/forms/Select'
import { isNil, orderBy, range } from 'lodash'
import moment from 'moment'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { pgsseIndicator } from 'pgsse/dto/PgsseShapes'
import { useParams } from 'react-router'
import { getBeginingOfTheYear, getYear } from 'utils/DateUtil'
import ToastrAction from 'toastr/actions/ToastrAction'
import { REDUCER_INDICATORS } from 'pgsse/constant/PgsseConstants'

const NewIndicatorDialog = ({
    isOpen = false,
    setIsOpen = () => { },
    updatedData = [],
    dispatchStateAUD = () => {},
}) => {
    const dispatch = useDispatch()

    const { idDiagnostic } = useParams()
    const {
        contributors,
        indicators,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        indicators: store.PgsseReducer.indicators,
    }), shallowEqual)

    const currentYear = moment().year()

    const [idOperator, setIdOperator] = useState()
    const [year, setYear] = useState(currentYear)
    const [idIndicator, setIdIndicator] = useState()

    const onSave = () => {
        if (isNil(idOperator) || isNil(year) || isNil(idIndicator)) {
            dispatch(ToastrAction.error(i18n.pleaseCompleteAllField))
        } else if (updatedData.some(ud => ud.idOperator === idOperator && ud.idIndicator === idIndicator && getYear(ud.month) === year)) {
            dispatch(ToastrAction.error(i18n.yearIsAlreadyTaken))
        } else {
            dispatchStateAUD({ type: REDUCER_INDICATORS.ADD, payload: [{ idDiagnostic: parseInt(idDiagnostic), idOperator, idIndicator, month: getBeginingOfTheYear(year) }] })
            setIsOpen(false)
        }
    }

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
        >
            <DefaultDialogTitle
                title='Saisie des indicateurs'
                onClose={() => setIsOpen(false)}
            />
            <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                    <Grid size={6}>
                        <Select
                            label={i18n.operator}
                            value={idOperator}
                            options={contributors}
                            onChange={setIdOperator}
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={i18n.indicator}
                            options={indicators}
                            value={idIndicator}
                            keyValue='idIndicator'
                            onChange={setIdIndicator}
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={i18n.year}
                            options={orderBy(range(currentYear - 20, currentYear + 1).map(v => ({ label: v, id: v })), 'id', 'desc')}
                            value={year}
                            noSort
                            onChange={setYear}
                            obligatory
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    onClick={onSave}
                >
                    {i18n.save}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

NewIndicatorDialog.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    updatedData: pgsseIndicator,
    dispatchStateAUD: PropTypes.func,
}

export default NewIndicatorDialog
